"use client";

import { Field, FieldError, useFieldWrapperContext } from "./field-wrapper";
import { SwitchItem } from "./switch-item";
import type { FieldBindingProps } from "./types";

export interface SwitchFieldProps extends FieldBindingProps<boolean> {
  label: string;
  description?: string;
  disabled?: boolean;
  isRequired?: boolean;
}

export function SwitchField({
  value,
  onChange,
  onBlur,
  errors,
  isTouched,
  isRequired,
  label,
  description,
  disabled,
}: SwitchFieldProps) {
  return (
    <Field errors={errors} isTouched={isTouched} isRequired={isRequired}>
      <FieldSwitchItem
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        label={label}
        description={description}
        disabled={disabled}
        isRequired={isRequired}
      />
      <FieldError />
    </Field>
  );
}

function FieldSwitchItem({
  value,
  onChange,
  onBlur,
  label,
  description,
  disabled,
  isRequired,
}: Pick<SwitchFieldProps, "value" | "onChange" | "onBlur" | "label" | "description" | "disabled" | "isRequired">) {
  const { id, hasError } = useFieldWrapperContext();
  return (
    <SwitchItem
      id={id}
      className="rounded-lg border"
      checked={value}
      onCheckedChange={(checked) => {
        onChange(checked);
        onBlur();
      }}
      label={
        <>
          {label}
          {isRequired && <span className="ml-0.5 text-destructive">*</span>}
        </>
      }
      description={description}
      disabled={disabled}
      invalid={hasError}
    />
  );
}
